var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import EdModal from "@frameworks/web/components/generic/edModal";
import { getImageString } from "@frameworks/salesjourney/utils/genericMethods";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import { ShowContacts } from "./AddContact/ShowContacts";
import FamilyTaggingDetailsPopUp from "./FamilyTaggingDetailsPopUp";
import ClientEmailVerifyPopUp from "./ClientEmailVerifyPopUp";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import leadDI from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
var PersonalDetails = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var _v = __read(React.useState(false), 2), resetFlow = _v[0], setResetFlow = _v[1];
    var _w = __read(React.useState(false), 2), addContact = _w[0], setAddContact = _w[1];
    var _x = __read(React.useState(false), 2), editContact = _x[0], setEditContact = _x[1];
    var _y = __read(React.useState(false), 2), showContacts = _y[0], setShowContacts = _y[1];
    var _z = __read(React.useState(false), 2), showDeleteConfirmation = _z[0], setShowDeleteConfirmation = _z[1];
    var _0 = __read(React.useState(0), 2), contactId = _0[0], setContactId = _0[1];
    var _1 = __read(React.useState(""), 2), mobileNumber = _1[0], setMobileNumber = _1[1];
    var _2 = __read(React.useState(""), 2), retypeContactNo = _2[0], setRetypeContactNo = _2[1];
    var _3 = __read(React.useState(""), 2), contactType = _3[0], setContactType = _3[1];
    var _4 = __read(React.useState(false), 2), successPopup = _4[0], setSuccessPopup = _4[1];
    var _5 = __read(React.useState(), 2), file = _5[0], setFile = _5[1];
    var _6 = __read(React.useState(), 2), isPartner = _6[0], setIsPartner = _6[1];
    var _7 = __read(React.useState(), 2), familyTaggingHeader = _7[0], setFamilyTaggingHeader = _7[1];
    var _8 = __read(React.useState(false), 2), familyTaggingDetailsPopUp = _8[0], setFamilyTaggingDetailsPopUp = _8[1];
    var _9 = __read(React.useState([]), 2), familyTaggingDetailsPopUpData = _9[0], setFamilyTaggingDetailsPopUpData = _9[1];
    var _10 = __read(React.useState(false), 2), familyTaggingDetailsPopUpLoader = _10[0], setFamilyTaggingDetailsPopUpLoader = _10[1];
    var _11 = __read(React.useState(false), 2), verifyEmailPopup = _11[0], setverifyEmailPopup = _11[1];
    var _12 = __read(useState(null), 2), isEmailVerified = _12[0], setIsEmailVerified = _12[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getClientImage = function () {
        var _a;
        if (props.clientOverviewData && props.clientOverviewData.profileImage)
            setFile(getImageString((_a = props.clientOverviewData) === null || _a === void 0 ? void 0 : _a.profileImage));
        else
            setFile("");
    };
    var getMultipleContacts = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) return [3 /*break*/, 2];
                    return [4 /*yield*/, di.clients.getClientMultipleContactsData({
                            acCode: selectedAcount.accountCode,
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getFamilyDetailsForPopUp = function (isMobile) {
        setFamilyTaggingDetailsPopUpLoader(true);
        setFamilyTaggingHeader(isMobile
            ? "Family Taggging Details - Mobile"
            : "Family Tagging Details - Email Id");
        di.clients
            .getfamilyDetails({
            AccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            forMobile: isMobile,
        })
            .then(function (resp) {
            setFamilyTaggingDetailsPopUpData(resp === null || resp === void 0 ? void 0 : resp.data);
            setFamilyTaggingDetailsPopUpLoader(false);
        })
            .catch(function () {
            setFamilyTaggingDetailsPopUpLoader(false);
        });
    };
    var getPartnerStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) return [3 /*break*/, 2];
                    return [4 /*yield*/, di.clients
                            .getPartnerStatus({
                            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        })
                            .then(function (partnerStatus) {
                            setIsPartner(partnerStatus === null || partnerStatus === void 0 ? void 0 : partnerStatus.data);
                        })
                            .catch(function (error) { })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getUCCStatus = function () {
        var payload = {
            source: leadStatusConfig.SalesSourceName,
            uccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode,
        };
        leadDI.leads
            .checkUccStatus(payload)
            .then(function (resp) {
            var _a, _b;
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.length) > 0) {
                if (((_a = resp[0]) === null || _a === void 0 ? void 0 : _a.isEmailVerify) === "" || ((_b = resp[0]) === null || _b === void 0 ? void 0 : _b.isEmailVerify.toLowerCase()) === "true") {
                    setIsEmailVerified(true);
                }
                else
                    setIsEmailVerified(false);
            }
            else {
                setIsEmailVerified(null);
            }
        })
            .catch(function (error) {
            setIsEmailVerified(null);
            console.log("error", error);
        });
    };
    React.useEffect(function () {
        if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode)
            getUCCStatus();
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode]);
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) {
            getClientImage();
            getPartnerStatus();
            //getMultipleContacts();
        }
    }, [selectedAcount]);
    React.useEffect(function () {
        if (!showContacts) {
            setEditContact(false);
            setAddContact(false);
            setSuccessPopup(false);
        }
    }, [showContacts]);
    React.useEffect(function () {
        if (showDeleteConfirmation) {
            setEditContact(true);
        }
    }, [showDeleteConfirmation]);
    return (React.createElement("section", { className: "personal-details section-padding element", id: "personal-details" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 py-2" }, "Personal Details"),
        React.createElement(Row, { className: " d-flex flex-column" },
            React.createElement(Col, { className: "client-labels d-flex  align-items-center " },
                React.createElement("div", { className: "profile-design-name" },
                    React.createElement("div", { className: "client-icon d-flex align-items-center justify-content-center" }, file ? (React.createElement("img", { alt: "Profile Picture", className: "rounded-circle profile-img", src: file })) : (React.createElement("i", { className: "edel-icon-user2 txt_primaryGrey" }))),
                    React.createElement("div", { className: "name-n-designation" },
                        React.createElement("label", { className: "DMSans_16_500 txt_blackOne1 text-center" }, addDashIfNullOrUndefined((_a = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _a === void 0 ? void 0 : _a.name)),
                        React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, addDashIfNullOrUndefined((_b = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _b === void 0 ? void 0 : _b.designation)))),
                ((_c = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _c === void 0 ? void 0 : _c.clientGroup) && (React.createElement("div", { className: " edel-tag  d-flex justify-content-center" },
                    React.createElement("span", { className: "DMSansMedium_12_500" }, addDashIfNullOrUndefined((_d = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _d === void 0 ? void 0 : _d.clientGroup))))),
            React.createElement(Col, { md: 12, lg: 12, xl: 12 },
                React.createElement("div", { className: "d-grid client-details" },
                    React.createElement("div", null,
                        React.createElement("span", { className: "DMSansMedium_12_500 txt_secondary-gray d-flex contact-btn align-items-center" },
                            "Mobile Number",
                            React.createElement("span", null,
                                React.createElement(EdButton, { className: "add-contact", btnTyp: "midnight-blue-underline", value: "View Contact", onClick: function (e) {
                                        e.stopPropagation();
                                        setShowContacts(true);
                                        getMultipleContacts();
                                    } }))),
                        React.createElement("div", { className: "d-flex align-items-center" },
                            React.createElement("span", { className: "RobotoM_14_500 txt_blackOne1 text-decoration-underline hand_cursor", onClick: function (e) {
                                    e.stopPropagation();
                                    setFamilyTaggingDetailsPopUp(true);
                                    getFamilyDetailsForPopUp(true);
                                } },
                                addDashIfNullOrUndefined((_e = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _e === void 0 ? void 0 : _e.mobileNo),
                                " "))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Phone Number",
                        React.createElement("div", { className: "RobotoM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_f = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _f === void 0 ? void 0 : _f.phoneNo))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray client-email" },
                        "Email ID",
                        React.createElement("div", { className: "d-flex align-items-center" },
                            React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 text-decoration-underline hand_cursor underline-text", onClick: function (e) {
                                    e.stopPropagation();
                                    setFamilyTaggingDetailsPopUp(true);
                                    getFamilyDetailsForPopUp(false);
                                } }, addDashIfNullOrUndefined((_g = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _g === void 0 ? void 0 : _g.emailId)),
                            isEmailVerified !== null && !isEmailVerified && ((_h = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _h === void 0 ? void 0 : _h.emailId) && (React.createElement(Edelicon, { className: "edel-icon-not-verified hand_cursor", onClick: function () {
                                    setverifyEmailPopup(true);
                                } })))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Preffered Language",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_j = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _j === void 0 ? void 0 : _j.preferredLang))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Gender",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_k = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _k === void 0 ? void 0 : _k.gender))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "DOB (Age)",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_l = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _l === void 0 ? void 0 : _l.dob))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Organization",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_m = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _m === void 0 ? void 0 : _m.organization))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Designation",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_o = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _o === void 0 ? void 0 : _o.designation))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "City",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_p = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _p === void 0 ? void 0 : _p.city))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "State",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_q = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _q === void 0 ? void 0 : _q.state))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Pin Code",
                        React.createElement("div", { className: "RobotoM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_r = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _r === void 0 ? void 0 : _r.pinCode))),
                    React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                        "Is Partner",
                        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(isPartner)))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray address-col" },
                    "Address",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined((_s = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _s === void 0 ? void 0 : _s.address))))),
        React.createElement("div", { className: addContact || editContact ? "" : "modal-fullwidth" },
            React.createElement(EdModal, { show: showContacts, setShow: function (val) {
                    setShowContacts(val);
                    setShowDeleteConfirmation(val);
                }, showFooter: false, modalTitle: addContact || editContact
                    ? "add-contact sales-client commonmodal ".concat(successPopup && "success-popup")
                    : "", children: 
                // addContact || editContact ? (
                //   <AddContact
                //     mobileNumber={mobileNumber}
                //     setMobileNumber={setMobileNumber}
                //     successPopup={successPopup}
                //     setSuccessPopup={setSuccessPopup}
                //     contactType={contactType}
                //     retypeContactNo={retypeContactNo}
                //     editContact={editContact}
                //     resetButton={resetFlow}
                //     showDeleteConfirmation={showDeleteConfirmation}
                //     contactId={contactId}
                //   />
                // ) : 
                (React.createElement(ShowContacts, { setNewAddContact: setShowContacts, setAddContact: setAddContact, setEditContact: setEditContact, setMobileNumber: setMobileNumber, setContactType: setContactType, setResetContact: setResetFlow, setRetypeContactNo: setRetypeContactNo, setShowDeleteConfirmation: setShowDeleteConfirmation, setContactId: setContactId })), title: showDeleteConfirmation
                    ? "Delete Contact"
                    : addContact
                        ? "Add Contact"
                        : editContact
                            ? "Edit Contact"
                            : "View Contact" })),
        familyTaggingDetailsPopUp && (React.createElement(EdModal, { show: familyTaggingDetailsPopUp, setShow: function (val) {
                setFamilyTaggingDetailsPopUp(val);
            }, size: "modal-dialog-centered", showFooter: false, modalTitle: "family-tagging-details", title: familyTaggingHeader, children: React.createElement(FamilyTaggingDetailsPopUp, { tbodyData: familyTaggingDetailsPopUpData, loader: familyTaggingDetailsPopUpLoader }), closeDropdown: function () { }, stopClossOnOutsideClick: true })),
        verifyEmailPopup && (React.createElement(EdModal, { show: verifyEmailPopup, setShow: function (val) {
                setverifyEmailPopup(val);
            }, size: "modal-dialog-centered", showFooter: false, modalTitle: "email-verify-popup", title: "Verify Email", children: React.createElement(ClientEmailVerifyPopUp, { prevEmailID: (_t = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _t === void 0 ? void 0 : _t.emailId, setverifyEmailPopup: setverifyEmailPopup, mobileNumber: (_u = props === null || props === void 0 ? void 0 : props.clientOverviewData) === null || _u === void 0 ? void 0 : _u.mobileNo, uccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode, getUCCStatus: getUCCStatus }), closeDropdown: function () { }, stopClossOnOutsideClick: true }))));
};
export default PersonalDetails;
